import * as types from './mutation-types'
import * as dashboardTypes from '../dashboard/mutation-types'
import * as documentTypes from '../documentType/mutation-types'

export const fetchOfferToSells = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/offer_to_sells`, {params}).then((response) => {
      commit(types.SET_OFFER_TO_SELLS, response.data.offerToSells.data)
      commit(types.SET_TOTAL_OFFER_TO_SELLS, response.data.offerToSells.total)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const fetchOfferToSell = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/offer_to_sells/${id}/edit`).then((response) => {
      commit(types.SET_TEMPLATE_ID, response.data.invoice.invoice_template_id)
      if (response.data.invoice) {
        response.data.invoice.discount_type = response.data.invoice.discount_type || 'fixed'
        response.data.invoice.discount_val = response.data.invoice.discount_val || 0
        response.data.invoice.discount = response.data.invoice.discount || 0
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const selectPreapprovedInvoice = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_PREAPPROVED_INVOICE, data)
}
export const fetchCreateInvoice = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/invoices/create`).then((response) => {
      commit('documentType/' + documentTypes.ATTACHMENTS, 'null', { root: true })
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const addAttachment = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/addAttachment`, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const fetchAttachments = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/attachments`, data).then((response) => {
      commit(types.ATTACHMENTS, response.data.islamicFinance.media)
      commit(types.SET_TOTAL_ATTACHMENTS, response.data.total)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const fetchAttachmentsByStatus = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/attachments-by-status`, data).then((response) => {
      commit(types.ATTACHMENTS, response.data.islamicFinance.media)
      commit(types.SET_TOTAL_ATTACHMENTS, response.data.total)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const selectAttachment = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_ATTACHMENTS, data)
  if (state.selectedAttachments.length === state.attachments.length) {
    commit(types.SET_SELECT_ALL_STATE_ATTACHMENT, true)
  } else {
    commit(types.SET_SELECT_ALL_STATE_ATTACHMENT, false)
  }
}

export const selectAllAttachments = ({ commit, dispatch, state }) => {
  if (state.selectedAttachments.length === state.attachments.length) {
    commit(types.SET_SELECTED_ATTACHMENTS, [])
    commit(types.SET_SELECT_ALL_STATE_ATTACHMENT, false)
  } else {
    let allAttachmentIds = state.attachments.map(cust => cust.id)
    commit(types.SET_SELECTED_ATTACHMENTS, allAttachmentIds)
    commit(types.SET_SELECT_ALL_STATE_ATTACHMENT, true)
  }
}

export const fetchInvoiceShow = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/invoices/${id}`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const addOfferToSell = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('/api/offer_to_sells', data).then((response) => {
      // commit(types.ADD_INVOICE, response.data)

      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const updateOfferToSell = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.put(`/api/offer_to_sells/${data.id}`, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const markAsOffer = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/mark-as-offer`, data).then((response) => {
      if (response.data.success) {
        commit(types.UPDATE_OFFER_TO_SELL_STATUS, { id: data.islamic_finance_id, status: 'OFFER' })
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const markAsInvoiceInformationAdded = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/mark-as-invoice-info-added`, data).then((response) => {
      if (response.data.success) {
        commit(types.UPDATE_OFFER_TO_SELL_STATUS, { id: data.islamic_finance_id, status: 'INVOICE_INFORMATION_ADDED' })
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const markAsManuallyInvoiceVerification = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/mark-as-manually-invoice-verification`, data).then((response) => {
      if (response.data.success) {
        commit(types.UPDATE_OFFER_TO_SELL_STATUS, { id: data.islamic_finance_id, status: 'INVOICE_VERIFIED' })
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const markAsAutoInvoiceVerification = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/mark-as-automatic-invoice-verification`, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const markAsAccept = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/mark-as-accepted`, data).then((response) => {
      if (response.data.success) {
        commit(types.UPDATE_OFFER_TO_SELL_STATUS, { id: data.islamic_finance_id, status: 'OFFER_TO_SELL_ACCEPT' })
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const markAsReject = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/mark-as-rejected`, data).then((response) => {
      if (response.data.success) {
        commit(types.UPDATE_OFFER_TO_SELL_STATUS, { id: data.islamic_finance_id, status: 'OFFER_TO_SELL_REJECT' })
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const markAsNoticeOfNotice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/mark-as-notice-delivery`, data).then((response) => {
      if (response.data.success) {
        commit(types.UPDATE_OFFER_TO_SELL_STATUS, { id: data.islamic_finance_id, status: 'NOTICE_OF_DELIVERY_ISSUED' })
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const markAsAgentAppoint = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/mark-as-agent-appoint`, data).then((response) => {
      if (response.data.success) {
        commit(types.UPDATE_OFFER_TO_SELL_STATUS, { id: data.islamic_finance_id, status: 'AGENCY_PENDING' })
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const markAsAgencyAccepted = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/mark-as-agency-accepted`, data).then((response) => {
      if (response.data.success) {
        commit(types.UPDATE_OFFER_TO_SELL_STATUS, { id: data.islamic_finance_id, status: 'AGENCY_ACCEPTED' })
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const markAsAgencyRejected = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/mark-as-agency-rejected`, data).then((response) => {
      if (response.data.success) {
        commit(types.UPDATE_OFFER_TO_SELL_STATUS, { id: data.islamic_finance_id, status: 'AGENCY_REJECTED' })
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const markAsSaleConfirmed = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/offer_to_sells/mark-as-sale-confirmed`, data).then((response) => {
      if (response.data.success) {
        commit(types.UPDATE_OFFER_TO_SELL_STATUS, { id: data.islamic_finance_id, status: 'SALE_CONFIRMED' })
      }
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const SingleIslamicFinanceArray = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/offer_to_sells/${id}/singleIslamicFinanceArray`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const cloneInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`/api/invoices/clone`, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}


export const searchInvoice = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/invoices?${data}`).then((response) => {
      // commit(types.UPDATE_INVOICE, response.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const selectOfferToSell = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_OFFERS, data)
  if (state.selectedOfferToSells.length === state.offerToSells.length) {
    commit(types.SET_SELECT_ALL_STATE, true)
  } else {
    commit(types.SET_SELECT_ALL_STATE, false)
  }
}

export const setSelectAllState = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECT_ALL_STATE, data)
}

export const selectAllOfferToSells = ({ commit, dispatch, state }) => {
  if (state.selectedOfferToSells.length === state.offerToSells.length) {
    commit(types.SET_SELECTED_OFFERS, [])
    commit(types.SET_SELECT_ALL_STATE, false)
  } else {
    let allInvoiceIds = state.offerToSells.map(inv => inv.id)
    commit(types.SET_SELECTED_OFFERS, allInvoiceIds)
    commit(types.SET_SELECT_ALL_STATE, true)
  }
}

export const resetSelectedOfferToSells = ({ commit, dispatch, state }) => {
  commit(types.SET_SELECTED_OFFERS)
}
export const setCustomer = ({ commit, dispatch, state }, data) => {
  commit(types.RESET_CUSTOMER)
  commit(types.SET_CUSTOMER, data)
}

export const resetCustomer = ({ commit, dispatch, state }) => {
  commit(types.RESET_CUSTOMER)
}

export const setTemplate = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    commit(types.SET_TEMPLATE_ID, data)
    resolve({})
  })
}

export const selectCustomer = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`/api/customers/${id}`).then((response) => {
      commit(types.RESET_SELECTED_CUSTOMER)
      commit(types.SELECT_CUSTOMER, response.data.customer)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const resetSelectedCustomer = ({ commit, dispatch, state }, data) => {
  commit(types.RESET_SELECTED_CUSTOMER)
}
export const FetchInvoiceSuppliers = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.get('/api/invoiceSuppliers', data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
